module.exports = __webpack_public_path__ + "static/logo-11b97cca66d2f1033bc59d4b36d057bc.svg";